import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { ActivityForm } from "../ActivityForm";
import { CreateActivityModalProps } from "./types";
import { useCreateActivityModal } from "./controller";

export const CreateActivityModal = React.memo(({ modalRef, onComplete }: CreateActivityModalProps) => {
  const translate = useTranslate();

  const { methods, mutateAsync, isPending } = useCreateActivityModal(modalRef, onComplete);

  return (
    <Modal
      ref={modalRef}
      title={translate("activity_admin.titles.create")}
      onConfirm={mutateAsync}
      methods={methods}
      isPending={isPending}
    >
      <ActivityForm />
    </Modal>
  );
});
